import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";


export const fetchDistrict = createAsyncThunk(
  "district/fetchDistrict",
  async () => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/district`);     
      return response.data.data;  
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);  
    }
  }
);

export const fetchDestinations = createAsyncThunk(
  "district/fetchDestinations",
  async (district) => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/destinations/${district}`);     
      return response.data.data;  
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);  
    }
  }
);

export const fetchDestinationDetails  = createAsyncThunk(
  "district/fetchDestinationDetails",
  async (destination) => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/destination-details/${destination}`);     
      return response.data.data;  
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);  
    }
  }
);

const districtSlice = createSlice({
  name: "district",
  initialState: {
    districtData: [],
    destinations: [],
    category: "",
    attractionpoint: "",
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistrict.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDistrict.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.districtData = action.payload;
        state.error = null;  
      })
      .addCase(fetchDistrict.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;  
      })
      .addCase(fetchDestinations.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDestinations.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.destinations = action.payload;
      })
      .addCase(fetchDestinations.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchDestinationDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDestinationDetails.fulfilled, (state, action) => {
        console.log("API Response:", action.payload); 
    state.status = "succeeded";
    
    if (action.payload) {
        state.category = action.payload[0].category;  
        state.attractionpoint = action.payload[0].attractionpoint;
    }

    console.log("Updated Redux State:", state);
      })
      .addCase(fetchDestinationDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

// Export reducer
export default districtSlice.reducer;